<dashboard-dialog-frame class="acc-session-viewer-dialog" [header]="headerTitle()" [actions]="actions" [dialogRef]="dialogRef">

	<kendo-tabstrip class="h-100 px-2 pt-2">

		<kendo-tabstrip-tab title="Details" [selected]="true">
			<ng-template kendoTabContent>
				<acc-session-details-part> </acc-session-details-part>
			</ng-template>
		</kendo-tabstrip-tab>

		<kendo-tabstrip-tab title="Sign-ups">
			<ng-template kendoTabContent>
				<acc-session-sign-ups-part [dialogBodyHeight]="dialogContext.dimensions().bodyHeight"></acc-session-sign-ups-part>
			</ng-template>
		</kendo-tabstrip-tab>

	</kendo-tabstrip>
</dashboard-dialog-frame>